import React from 'react';
type SectionHeadingProps = {
  kicker?: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: 'light' | 'dark';
};
export function SectionHeading({
  kicker,
  title,
  intro,
  tone = 'light'
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-253" data-mp="3k06w9t0d6pxq">
      {kicker && <p className={`mb-3 text-sm font-bold uppercase tracking-wider ${dark ? 'text-teal-light' : 'text-teal-dark'}`} data-id="element-254" data-mp="3k0f6fd53rh58">{kicker}</p>}
      <h2 className={`font-display text-[2.1rem] font-extrabold uppercase leading-[1.02] sm:text-5xl ${dark ? 'text-white' : 'text-navy'}`} data-id="element-255" data-mp="gj6qwzxuktdo">
        {title}
      </h2>
      {intro && <div className={`mt-4 text-lg leading-relaxed ${dark ? 'text-white/80' : 'text-muted'}`} data-id="element-256" data-mp="6tdi26p3asd4">{intro}</div>}
    </div>;
}